import { useEffect } from "react";
import { Image, Button } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getUser } from "src/modules/auth/duck/selectors";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { H2, BodyText } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import getImageSrc from "src/utils/getImageSrc";
import time from "src/utils/time";

export default function RedeemSuccess({ closeWizard }) {
  const navigate = useNavigate();
  const user = useSelector(getUser);
  const { t } = useTranslation();

  const premiumEndDate = time(user?.subscription?.expirationDate).format(
    "DD.MM.YYYY"
  );

  function onDone() {
    navigate("/dashboard");
    closeWizard();
  }

  const string = t("redeem.success", {
    value0: `<span class="styledDate">${premiumEndDate}</span>`
  });

  useEffect(() => {
    const el = document.getElementById("styledText");
    el.innerHTML = string;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SceneLayout
        centerProps={{ width: "320px" }}
        center={
          <>
            <Image src={getImageSrc("success-star.svg")} width="176px" />
            <H2 color="highEmphasis" textAlign="center" mt="24px">
              {t("pawesome")}
            </H2>

            <BodyText
              id="styledText"
              color="mediumEmphasis"
              textAlign="center"
              mt="8px"
              whiteSpace="pre-line"
              sx={{
                ".styledDate": {
                  fontWeight: 500,
                  color: "highEmphasis"
                }
              }}
            >
              {t("redeem.success", {
                value0: premiumEndDate
              })}
            </BodyText>
          </>
        }
        bottomProps={{ mb: "24px" }}
        bottom={
          <>
            <Button
              variant="containedPrimary"
              onClick={onDone}
              mt="32px"
              minWidth="120px"
            >
              {t("buttons.done")}
            </Button>
          </>
        }
      />
    </>
  );
}
